import React from 'react'
// antd-pro
import {ProFormSelect, ProFormText} from '@ant-design/pro-components'
// api
import Api from '@/api'
import {AppType} from '@/enum'
import {IsManagerPro} from '@/utils'


/**
 * 纷享销客表单项
 * @constructor
 */
const FxxkFormItems = () => {

  return (
    <>
      <ProFormText
        name={["config", "appId"]}
        label={"应用id"}
        placeholder={"请输入应用Id"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入应用id"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={['config', 'appSecret']}
        label={"应用秘钥"}
        placeholder={"请输入应用秘钥"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入应用秘钥"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
        ]}
      />
      <ProFormText
        name={["config", "permanentCode"]}
        label={"pCode"}
        placeholder={"请输入permanentCode"}
        required
        width={"lg"}
        rules={[{
          required: true,
          message: "请输入permanentCode"
        }]}
      />
      <ProFormText
        name={["config", "mobile"]}
        label={"管理员手机号"}
        placeholder={"请输入管理员手机号"}
        required
        width={"lg"}
        rules={[{
          required: true,
          message: "请输入管理员手机号"
        }]}
      />
      <ProFormText
        name={["config", "corpId"]}
        label={"企业Id"}
        placeholder={"请输入企业Id"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入企业Id"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "corpAccessToken"]}
        label={"corpAT"}
        placeholder={"请输入corpAccessToken"}
        required
        width={"lg"}
        rules={[
          {
          required: true,
          message: "请输入corpAccessToken"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "openUserId"]}
        label={"openUserId"}
        placeholder={"请输入openUserId"}
        required
        width={"lg"}
        rules={[
          {
          required: true,
          message: "请输入openUserId"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormSelect
        name={["config", "envId"]}
        initialValue={2}
        label={"环境地址"}
        placeholder={"请选择所属环境地址"}
        required
        hidden={!IsManagerPro}
        width={"lg"}
        rules={[{
          required: true,
          message: "请选择所属环境地址"
        }]}
        fieldProps={{
          fieldNames: {
            label: "envName",
            value: "id"
          }
        }}
        request={async () => {
          const _data: any = await Api.Common.EnvList({appType: AppType.FXXK})
          return _data
        }}
      />
    </>
  )
}

export default FxxkFormItems
